// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__lY+nO","left":"Virtual_left__csH+6","wrapper":"Virtual_wrapper__KMQgc"};